// @ts-nocheck
import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import { dataEmissaoRequerimento } from "../../data/dataEmissaoRequerimento";
import { Explicacao } from "./styles";

// Os textos usam **negrito**; o resto é texto puro.
function Rico({ texto }) {
  return texto.split(/(\*\*[^*]+\*\*)/g).map((parte, i) =>
    parte.startsWith("**") ? <strong key={i}>{parte.slice(2, -2)}</strong> : <React.Fragment key={i}>{parte}</React.Fragment>
  );
}

function Lista({ itens, numerada }) {
  const Tag = numerada ? "ol" : "ul";
  return (
    <Tag>
      {itens.map((item) => (
        <li key={item}>
          <Rico texto={item} />
        </li>
      ))}
    </Tag>
  );
}

export function ModalRequerimento({ emissao, onClose }) {
  if (!emissao) return null;

  const conteudo = dataEmissaoRequerimento({ certidao: emissao.certidao, titular: emissao.titular });

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      scroll="body"
      aria-labelledby="titulo-requerimento"
      PaperProps={{ style: { margin: 16, width: "calc(100% - 32px)", maxWidth: 600, borderRadius: 16 } }}
    >
      <DialogContent style={{ padding: "24px", position: "relative" }}>
        <IconButton aria-label="Fechar" onClick={onClose} style={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
        <Explicacao>
          <h2 id="titulo-requerimento" style={{ paddingRight: 40 }}>{conteudo.titulo}</h2>
          {conteudo.introducao.map((p) => (
            <p key={p}>
              <Rico texto={p} />
            </p>
          ))}
          {conteudo.secoes.map((secao) => (
            <React.Fragment key={secao.titulo}>
              <h3>{secao.titulo}</h3>
              {secao.texto && <p>{secao.texto}</p>}
              {secao.itens && <Lista itens={secao.itens} numerada={secao.numerada} />}
              {secao.dica && (
                <p className="dica">
                  <Rico texto={secao.dica} />
                </p>
              )}
              {secao.opcoes &&
                secao.opcoes.map((opcao) => (
                  <React.Fragment key={opcao.titulo}>
                    <h4>{opcao.titulo}</h4>
                    {opcao.texto.split("\n\n").map((p) => (
                      <p key={p}>{p}</p>
                    ))}
                    <Lista itens={opcao.itens} numerada={opcao.numerada} />
                  </React.Fragment>
                ))}
              {secao.paragrafos &&
                secao.paragrafos.map((p) => (
                  <p key={p}>
                    <Rico texto={p} />
                  </p>
                ))}
            </React.Fragment>
          ))}
        </Explicacao>
      </DialogContent>
    </Dialog>
  );
}
